import React, { Fragment } from "react";

const Loader = ({ isLoading }) => {
  return <Fragment>{isLoading ? <div id="loader" /> : null}</Fragment>;
};

export default Loader;



// WEBPACK FOOTER //
// ./src/components/common/Loader.jsx